const IS_APP_DEVELOPMENT = import.meta.env.VITE_APP_ENV === 'development';

type LogLevel = 'log' | 'warn' | 'error';

type FrontendLogEntry = {
  level: LogLevel;
  scope: string;
  message: string;
  payload?: unknown;
  timestamp: string;
};

const MAX_BUFFER = 50;
const frontendLogBuffer: FrontendLogEntry[] = [];

function pushToBuffer(entry: FrontendLogEntry) {
  frontendLogBuffer.push(entry);
  if (frontendLogBuffer.length > MAX_BUFFER) {
    frontendLogBuffer.shift();
  }
}

export function getFrontendLogSnapshot(): FrontendLogEntry[] {
  return [...frontendLogBuffer];
}

function log(level: LogLevel, scope: string, message: string, payload?: unknown) {
  const entry: FrontendLogEntry = {
    level,
    scope,
    message,
    payload,
    timestamp: new Date().toISOString(),
  };

  pushToBuffer(entry);

  if (!IS_APP_DEVELOPMENT) return;

  const consoleMethod =
    level === 'warn' ? console.warn : level === 'error' ? console.error : console.log;

  if (typeof payload === 'undefined') {
    consoleMethod(`[DEV][${scope}] ${message}`);
    return;
  }
  consoleMethod(`[DEV][${scope}] ${message}`, payload);
}

export function devLog(scope: string, message: string, payload?: unknown) {
  log('log', scope, message, payload);
}

export function devWarn(scope: string, message: string, payload?: unknown) {
  log('warn', scope, message, payload);
}

export function devError(scope: string, message: string, payload?: unknown) {
  log('error', scope, message, payload);
}
